import React, {useEffect} from 'react';
import {Row, Col} from 'reactstrap';
import TextInput from '../../../Shared/TextInput/TextInput';
import CheckBox from '../../../Shared/CheckBox/Checkbox';
import EpiContext from '@episerver/spa-core/Spa';
import {prepareUrl} from '../../../../utilities/StringHelpers/StringHelpers';


const EmailComponent = (props) => {

    useEffect(() => {
      if (props.onSubmit && props.onSubmit == true) {
        props.validateEmail(props.email);
      }
      
    }, [props.onSubmit]);

  return (
    <div className=''>
      <Row>
        <Col className='input-container'>
            <p className="bold email-title">לאיזה מייל לשלוח את אישור העדכון?</p>            

            <TextInput 
                required={true}
                error={props.email.errors.email} 
                onChange={(e) => props.changeHandler({target : e.target, form : props.email})} 
                value={props.email.email}
                name="email"
                type="email" 
                placeholder="כתובת מייל"
            />
          {props.showAgreement &&
            <Row className='termOfService'>
                <Col xs='1' md='1' className='termOfService__checkbox pr-0 pl-0'> 
                  <div>
                    <CheckBox
                      id='agreement'
                      onCheck={(e) => props.onCheck(e)}
                      onUncheck={(e) => props.onCheck(e)}
                      checked={props.checked}
                      >
                      </CheckBox>
                  </div>
                </Col>
                <Col xs='11' md='11'>
                  <p className='termOfService__link'>
                    אישרתי את{' '}
                    <span className='termOfService__link__url' onClick = {() => prepareUrl(props.termsLink, EpiContext)} >
                      תקנון השירות
                    </span>
                  </p>
                </Col>
              </Row>
            }
        </Col>
      </Row>
    </div>
  );
};

export default EmailComponent;
